import { Accordion, AccordionItem } from '@design-system';
import { FC } from 'react';
import { render } from 'storyblok-rich-text-react-renderer-ts';

interface Props extends StoryblokSectionFAQs {
  onQuestionClick?: (title: string) => void;
}

export const SectionFAQs: FC<Props> = ({ faqs, onQuestionClick }) => (
  <div className="grid-section scroll-mt-24" id="FAQs">
    <div className="col-span-12 md:col-span-8 md:col-start-3 lg:col-span-6 lg:col-start-4">
      <div className="flex flex-col gap-y-3 rounded-sm border border-divider/20 px-4">
        <Accordion>
          {faqs.map((item) => (
            <AccordionItem
              key={item.title}
              analytics={() => onQuestionClick?.(item.title)}
              subject={item.title}
            >
              {render(item.text)}
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </div>
);
